/*
 *  -----------------------------------------------------------------------
 *    <copyright file="login.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import './login.scss';
import { useTranslation } from 'react-i18next';

const LoginLayout = ({ children }: any) => (
    <div className="login-layout">
        <div className="grid controls-grid-offset">
            <div className="main-container-wrapper">
                <div className="main-container">
                    <div className="content-frame transparent-fill">
                        <img alt="" src="/img/normal_opra_logo_u58.png" className="opra-logo" />
                        {children}

                        {/* Push the term and conditions link to the bottom of the page/column */}
                        <div style={{ flexGrow: 1 }} />

                        {/* We always want a terms and conditions link at the bottom of the page  */}
                        {/* <Link to={Routes.path('terms')} className="terms-conditions-link"> */}
                        {/*    {t('login:termsConditions')} */}
                        {/* </Link> */}
                    </div>
                </div>
                <p className="footer-text">
                    This system is for the use of those Subscribers authorized by the Service Provider, and individual
                    users authorized by those Subscribers (“User”); others who access the system may be subject to
                    criminal prosecution. Authorized use is governed by the terms of use set out in the respective Terms
                    of Business/ SaaS License Agreement entered into between the Subscriber and the Service Provider,
                    institutional policy and by country, state and federal laws, and each User is responsible for
                    familiarity and compliance with their provisions. Usage may also be subject to monitoring and
                    testing.
                    <br />
                    <br />
                    Use of this system by a Subscriber, and individual Users authorized by those Subscribers, is deemed
                    to provide acceptance to the terms of the Service Provider’s Privacy Policy (
                    <a href="https://tritrials.com/privacy-policy" target="_new">
                        https://tritrials.com/privacy-policy
                    </a>
                    ), and Cookie Policy (
                    <a href="https://tritrials.com/cookie-policy" target="_new">
                        https://tritrials.com/cookie-policy
                    </a>
                    ) as amended and updated from time to time.
                </p>
            </div>
        </div>
    </div>
);

export default LoginLayout;
